"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionNotificationDataHooks = exports.SectionNotificationSize = exports.SectionNotificationType = void 0;
var SectionNotificationType;
(function (SectionNotificationType) {
    SectionNotificationType["default"] = "default";
    SectionNotificationType["error"] = "error";
    SectionNotificationType["alert"] = "alert";
    SectionNotificationType["wired"] = "wired";
    SectionNotificationType["success"] = "success";
})(SectionNotificationType = exports.SectionNotificationType || (exports.SectionNotificationType = {}));
var SectionNotificationSize;
(function (SectionNotificationSize) {
    SectionNotificationSize["regular"] = "regular";
    SectionNotificationSize["compact"] = "compact";
})(SectionNotificationSize = exports.SectionNotificationSize || (exports.SectionNotificationSize = {}));
var SectionNotificationButton_1 = require("./Button/SectionNotificationButton");
Object.defineProperty(exports, "BUTTON_PRIORITY", { enumerable: true, get: function () { return SectionNotificationButton_1.BUTTON_PRIORITY; } });
Object.defineProperty(exports, "TEXT_BUTTON_PRIORITY", { enumerable: true, get: function () { return SectionNotificationButton_1.TEXT_BUTTON_PRIORITY; } });
Object.defineProperty(exports, "BUTTON_TYPE", { enumerable: true, get: function () { return SectionNotificationButton_1.BUTTON_TYPE; } });
var SectionNotificationDataHooks;
(function (SectionNotificationDataHooks) {
    SectionNotificationDataHooks["icon"] = "icon";
    SectionNotificationDataHooks["text"] = "text";
    SectionNotificationDataHooks["button"] = "button";
})(SectionNotificationDataHooks = exports.SectionNotificationDataHooks || (exports.SectionNotificationDataHooks = {}));
//# sourceMappingURL=types.js.map